import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/axios';
import SectionInspection from './SectionInspection';
import AppShell from '../components/AppShell';

export default function DynamicInspectionSection() {
  const { sectionPath } = useParams();
  const [type, setType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;

    const loadType = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get('/inspection-types');
        if (!mounted) return;

        const matched = (res.data || []).find((item) => item.is_active && item.route_path === sectionPath);

        if (!matched) {
          setError('نوع الفحص غير موجود أو لم يتم تهيئة المسار الخاص به.');
          setType(null);
          return;
        }

        if (!matched.supports_items) {
          setError('هذا النوع لا يدعم شاشة البنود العامة، ويحتاج شاشة مخصصة.');
          setType(null);
          return;
        }

        setType(matched);
      } catch (err) {
        if (!mounted) return;
        setError(err?.response?.data?.message || 'تعذر تحميل إعدادات نوع الفحص.');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    loadType();

    return () => {
      mounted = false;
    };
  }, [sectionPath]);

  if (loading) {
    return (
      <AppShell title="جاري التحميل">
        <div className="rounded-xl border border-blue-200 bg-blue-50 p-3 text-sm text-blue-700">
          جاري تحميل إعدادات نوع الفحص...
        </div>
      </AppShell>
    );
  }

  if (error || !type) {
    return (
      <AppShell title="نوع فحص غير متاح">
        <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">
          {error || 'هذا النوع غير متاح حالياً.'}
        </div>
      </AppShell>
    );
  }

  return (
    <SectionInspection
      section={type.key}
      title={type.name}
      saveEndpointPath={`sections/${type.save_endpoint || type.key}`}
    />
  );
}
